export function useDisplayStringLimit() {
  const limitDisplayString = (text, limit = 20) => {
    return `${text}`.length > limit
      ? `${text}`.substring(0, limit) + "..."
      : text;
  };
  return limitDisplayString;
}



// WEBPACK FOOTER //
// ./src/views/AppViews/Financial/components/ImportWithGPTVision/hooks/index.js